import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=fdf3af96&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=ts&"
export * from "./Product.vue?vue&type=script&lang=ts&"
import style0 from "./Product.vue?vue&type=style&index=0&id=fdf3af96&prod&lang=css&"
import style1 from "./Product.vue?vue&type=style&index=1&id=fdf3af96&prod&lang=scss&"
import style2 from "./Product.vue?vue&type=style&index=2&id=fdf3af96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf3af96",
  null
  
)

export default component.exports